module.exports = __webpack_public_path__ + "img/cekongjishu.6486c7dd.jpg";